<style scoped>
    .humTogMainform {
        background-color: #F8F8F8;
        padding: 20px 20px 50px 20px;
    }

    .lexjwa {
        width: 500px;
        float: right;
    }

    .lexjwa_bajalex div {
        display: inline-block;

    }

    .lexjwa_bajalex {
        padding: 8px 24px 24px 24px;
        background-color: #ffffff;
        margin-bottom: 20px;
    }

    .humtoglabel {
        position: relative;
        top: 7px;
    }

    .togtype {
        /*padding-top: 10px;*/
    }

    .submit_tog {
        float: right !important;
    }

    .upload-demo {
        text-align: center;
    }

    .post_froms {
        max-width: 900px;
        margin: 0 auto;
    }


    .el-row {
        margin-bottom: 20px;

        &:last-child {
            margin-bottom: 0;
        }
    }

    .bg-purple {
        background: #fcfcfc;
    }

    .grid-content {
        border-radius: 5px;
        padding: 15px;
    }

    .sub-title {
        font-size: 16px;
        padding: 10px;
    }

    .buttons {
        margin-bottom: 0;
        padding: 5px;
    }

    .rulelist {
        margin-top: 0;
        margin-bottom: 2px;
    }


</style>
<template>
    <!--<el-dialog title="New Submission"-->
    <!--:visible="visible"-->
    <!--:width="isMobile ? '99%' : '600px'"-->
    <!--@close="close"-->
    <!--append-to-body-->
    <!--class="user-select submit-form">-->
    <el-row :gutter="24" v-if="isLoggedIn">
        <el-col :span="24">
            <el-form class="post_froms" label-position="top" label-width="10px">
                <el-tabs @tab-click="handleClick" v-model="submissionType">
                    <el-tab-pane label="Text" name="text"></el-tab-pane>
                    <el-tab-pane label="Photos" name="img"></el-tab-pane>
                    <el-tab-pane label="Links" name="link"></el-tab-pane>
                </el-tabs>
                <el-row :gutter="20">
                    <el-col :span="24">
                        <div class="grid-content bg-purple">
                            <!-- Link -->
                            <el-form-item v-if="submissionType === 'News'||submissionType === 'link'">
                                <el-input placeholder="Link"
                                          name="url"
                                          v-model="submitURL"
                                          :disabled="can"
                                ></el-input>
                                <el-alert v-for="e in errors.url"
                                          :title="e"
                                          type="error"
                                          :key="e">
                                </el-alert>
                            </el-form-item>

                            <!-- Title -->
                            <el-form-item v-if="submissionType !== 'News' && submissionType !== 'link'">
                                <el-input placeholder="Title"
                                          class="input-with-select"
                                          name="title"
                                          :maxlength="250"
                                          :minlength="4"
                                          :disabled="can"
                                          v-model="title">
                                </el-input>

                                <el-alert v-for="e in errors.title"
                                          :title="e"
                                          type="error"
                                          :key="e">
                                </el-alert>
                            </el-form-item>

                            <el-form-item v-if="submissionType === 'article' || submissionType === 'text' ">
                                <CKEditorComponent v-if="loadEditor"
                                                   @input="input"
                                                   :height="'80%'"
                                                   v-model="text"
                                >
                                </CKEditorComponent>

                                <el-alert v-for="e in errors.description"
                                          :title="e"
                                          type="error"
                                          :key="e">
                                </el-alert>
                            </el-form-item>


                            <el-form-item v-if="submissionType === 'img'"
                                          label="Photo(s):">
                                <el-upload class="upload-demo"
                                           drag
                                           :limit="20"
                                           action="/api/photos"
                                           :file-list="photos"
                                           :on-preview="photoPreview"
                                           :on-remove="removePhoto"
                                           :on-success="successfulPhotoUpload"
                                           :on-exceed="exceededPhotoFileCount"
                                           :on-error="failedPhotoUpload"
                                           :before-upload="beforePhotoUploadCheckings"
                                           with-credentials
                                           accept=" .jpg, .jpeg, .png"
                                           :headers="{ 'X-CSRF-TOKEN': csrf}">
                                    <i class="el-icon-upload"></i>
                                    <div class="el-upload__text banu">Drop photo here or
                                        <em>click to upload</em>
                                    </div>
                                    <div class="el-upload__tip qudisia"
                                         slot="tip">Up to {{ photosNumberLimit }} jpg/png files with a size less than {{
                                        photosSizeLimit }}mb
                                    </div>
                                </el-upload>
                                <el-dialog :visible.sync="previewPhotoModal"
                                           :title="previewPhotoFileName"
                                           append-to-body>
                                    <img width="100%"
                                         :src="previewPhotoImage"
                                         alt="preview">
                                </el-dialog>
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="12">
                    </el-col>
                    <el-col :span="12">
                        <div class="grid-content bg-purple">
                            <div class="sub-title"> Where does this post belong in?</div>
                            <el-form-item>
                                <el-select v-model="selectedCat"
                                           filterable
                                           :filter-method="filterMethod"
                                           placeholder="Name of the page like Politics(India)"
                                           :disabled="can"
                                >
                                    <el-option v-for="item in channels"
                                               :key="item.id"
                                               :label="`${item.title} (${item.location.name})`"
                                               :value="item.name"
                                    ></el-option>
                                </el-select>
                                <el-alert v-for="e in errors.channel_name"
                                          :title="e"
                                          type="error"
                                          :key="e">
                                </el-alert>
                            </el-form-item>
                        </div>
                    </el-col>

                    <el-col :span="12">
                        <div class="grid-content bg-purple">
                            <div class="sub-title"> Rules</div>
                            <div v-html="channelRules"></div>
                        </div>
                    </el-col>
                </el-row>

                <el-row :gutter="20">
                    <el-col :span="24">
                        <div class="grid-content bg-purple">
                            <el-row class="buttons">
                                <el-col :span="21">
                                    <el-button v-if="typeOfSubmission === 'serious'"
                                               @click.prevent="typeOfSubmission = 'relaxed'"
                                               type="primary">Serious
                                    </el-button>
                                    <el-button v-else :disabled="disabledTypeOfSubmissionField || can"
                                               @click.prevent="typeOfSubmission = 'serious'">Serious
                                    </el-button>

                                 <!--   <el-button v-if="sfw" type="primary" @click="sfw = !sfw">NSFW</el-button>
                                    <el-button v-else @click="sfw = !sfw">NSFW</el-button> -->


                                    <el-button v-if="original" @click="original = !original" type="primary">Original
                                    </el-button>
                                    <el-button v-else @click="original = !original">Original</el-button>
                                </el-col>

                                <el-col :span="3">
                                    <el-button type="primary"
                                               @click="submit"
                                               :disabled="!goodToGo"
                                               :loading="loading">
                                        Publish
                                    </el-button>
                                </el-col>
                            </el-row>
                        </div>
                        <el-alert v-for="e in errors.submissionType"
                                  :title="e"
                                  type="error"
                                  :key="e">
                        </el-alert>
                    </el-col>
                </el-row>
            </el-form>
        </el-col>

        <div class="submit-type" style="display: none">
            <el-tooltip content="Photo(s)"
                        placement="top"
                        transition="false"
                        :open-delay="500">
                <i class="v-icon v-photo"
                   :class="{ 'go-primary': submissionType == 'img'}"
                   @click="changeSubmissionType('img')"></i>
            </el-tooltip>

            <el-tooltip content="News"
                        placement="top"
                        transition="false"
                        :open-delay="500">
                <i class="v-icon v-link"
                   :class="{ 'go-primary': submissionType == 'News'}"
                   @click="changeSubmissionType('News')"></i>
            </el-tooltip>

            <el-tooltip content="Text"
                        placement="top"
                        transition="false"
                        :open-delay="500">
                <i class="v-icon v-text"
                   :class="{ 'go-primary': submissionType == 'Question'}"
                   @click="changeSubmissionType('Question')"></i>
            </el-tooltip>
        </div>

        <!--<el-col :span="6">-->
        <!--&lt;!&ndash;<community-side-bar></community-side-bar>&ndash;&gt;-->
        <!--</el-col>-->
    </el-row>
    <!--</el-dialog>-->
</template>

<script>
    import Markdown from '../../components/Markdown.vue';
    import CommunitySideBar from '../../components/sidebars/CommunitySideBar.vue';
    import Helpers from '../../mixins/Helpers';
    import SubmitFormUpload from '../../mixins/SubmitFormUpload';
    import CKEditorComponent from "../CKEditor";

    export default {
        props: ['visible'],
        mixins: [Helpers, SubmitFormUpload],
        components: {CKEditorComponent, Markdown, CommunitySideBar},
        beforeRouteEnter(to, from, next) {
            if (to.params.slug) {
                let slug = to.params.slug
                axios.get(`/submission-owner/${slug}`).then(response => {
                    if (response.data.can) {
                        next(true)
                    } else {
                        next('/')
                    }
                });
            } else {
                next(true)
            }
        },

        beforeRouteUpdate(to, from, next) {
            if (to.params.slug) {
                let slug = to.params.slug
                axios.get(`/submission-owner/${slug}`).then(response => {
                    if (response.data.can) {
                        next(true)
                    } else {
                        next('/')
                    }
                });
            } else {
                next(true)
            }
        },
        data() {
            return {
                submission: {
                    user_id: '',
                    type: ''
                },
                errors: [],
                location: '',
                locations: [],

                original: false,
                timeRelevance: 'one_day',
                newsworthy: false,

                loading: false,
                loadingChannels: false,
                selectedCat: null,
                suggestedCats: [],
                submissionType: 'text',
                submissionGroup: 'default',
                submissionName: null,
                title: '',
                sfw: true,
                typeOfSubmission: 'relaxed',

                // Link
                submitURL: '',
                loadingTitle: false,

                // Text
                preview: false,
                text: '',

                // Photo
                photos: [],
                photosNumberLimit: 20,
                photosSizeLimit: 10,
                previewPhotoImage: '',
                previewPhotoFileName: '',
                previewPhotoModal: false,

                disabledField: false,
                disabledTypeOfSubmissionField: false,
                slug: '',
                channelRules: '<ol class="rulelist"><li> Be nice and respectful</li> <li> Post to right categories.</li> </ol>',
                channelsOriginal: [],
                channels: [],

                // GIF
                // gifTempArray: [],
                // gif_id: null,
                // gifNumberLimit: 1,
                // gifSizeLimit: 50,
                // previewGifImage: '',
                // previewGifFileName: '',
                // previewGifModal: false
            };
        },

        computed: {
            goodToGo() {
                if (this.submissionType == 'link') {
                    return this.selectedCat && this.submitURL && !this.loading;
                    // return this.title.trim().length > 0 && this.selectedCat && this.submitURL && !this.loading;
                }

                if (this.submissionType == 'img') {
                    return this.title.trim().length > 0 && this.selectedCat && this.photos.length && !this.loading;
                }

                return this.title.trim().length > 0 && this.selectedCat && !this.loading;
            },
            can() {
                if (this.isHumtogAdministrator) {
                    return false
                }
                return !!this.slug;
            },
        },

        created() {
            this.submissionType = this.$route.params.pt || 'text';
            this.submissionGroup = this.$route.query.type || 'default';
            this.submissionName = this.$route.query.name || null;

            // setTimeout(() => {
            //     this.setDefaultChannels();
            // }, 3000)

            let slug = this.$route.params.slug
            if (slug) {
                this.getSubmission(slug)
                this.submissionGroup = 'edit'
                this.submissionName = slug
            } else {
                this.loadEditor = true
            }
            this.getChannels()
            this.submitApi();
            this.getLocations();
        },

        watch: {
            visible() {
                if (this.visible) {
                    this.setDefaultChannels();
                    this.submitApi();
                    window.location.hash = 'newSubmission';
                } else {
                    if (window.location.hash == '#newSubmission') {
                        history.go(-1);
                    }
                }
            },
            '$route.params.pt'(newval) {
                this.submissionType = newval;
            },

            selectedCat(newSelectedChannel) {
                this.disabledTypeOfSubmissionField = false

                this.channels.forEach(channel => {
                    if (channel.name == newSelectedChannel) {
                        this.channelRules = channel.rules;
                        if (!!channel.type) {
                            if (channel.type == 'serious') {
                                this.typeOfSubmission = 'serious'
                            } else {
                                this.typeOfSubmission = 'relaxed'
                            }
                            this.disabledTypeOfSubmissionField = true
                        }
                    }
                });
            },
        },

        methods: {
            handleClick(tab) {
                this.submissionType = tab.name;
            },

            filterMethod(filterValue) {
                console.log(filterValue)

                this.channels = this.channelsOriginal
                if (!!filterValue) {
                    this.channels = this.channels.filter(channel => {
                        // let str = option.label.replace(/[)(]/, '');
                        let str = channel.title + ' ' + channel.location.name
                        return str.toLowerCase().includes(filterValue.toLowerCase())
                    })
                }
            },
            getChannels() {
              axios.get('/get-all-channels', {
                  params: {
                      type: this.submissionGroup,
                      name: this.submissionName
                  }
              }).then(res => {
                    this.channelsOriginal = res.data.data
                    this.channels = res.data.data
                    this.selectedCat = res.data.data[0].name;
                })
            },

            getSubmission(slug) {
                axios.get(`${Laravel.url}/api/submissions`, {params: {slug}})
                    .then(response => {
                        this.submitURL = (!!response.data.data.content.url) ? response.data.data.content.url : '';
                        this.title = response.data.data.title;
                        this.selectedCat = `${response.data.data.channel_name} (${response.data.data.location.name})`;
                        this.submissionType = response.data.data.type;
                        this.submission.type = response.data.data.typeSubmission;
                        this.submission.user_id = response.data.data.user_id;
                        this.location = response.data.data.location.id;
                        this.text = response.data.data.content.description;
                        this.original = !!response.data.data.original;
                        this.newsworthy = !!response.data.data.newsworthy;
                        this.timeRelevance = response.data.data.timeRelevance;
                        this.loadEditor = true;
                        this.sfw = response.data.data.nsfw;

                        if (!!response.data.data.photo) {
                            this.photos.push(response.data.data.photo);
                            this.previewPhotoImage = response.data.data.photo.path
                        }
                    });

                // this.disabledField = true
                this.slug = slug
            },

            getLocations() {
                axios.get(`${Laravel.url}/location`).then(response => {
                    if (response.status == 200) {
                        this.locations = response.data.data.map(item => ({
                            label: item.name,
                            value: item.id
                        }));
                    }
                })
            },

            input(val) {
                this.text = val
            },

            // onEditorBlur(quill) {
            //     console.log('editor blur!', quill)
            // },
            // onEditorFocus(quill) {
            //     console.log('editor focus!', quill)
            // },
            // onEditorReady(quill) {
            //     console.log('editor ready!', quill)
            // },
            // onEditorChange({quill, html, text}) {
            //     console.log('editor change!', quill, html, text)
            //     this.content = html
            // },

            close() {
                this.$emit('update:visible', false);
            },

            /**
             * Used for setting the values using API. This will get extended in the future to support
             * Humtog sharing buttons! But for now we are just going to use it for setting the default
             * channel so when clicked on submit in the channels, users won't have to set channel.
             *
             * @return
             */
            submitApi() {

                if (this.$route.params.name) {
                    this.selectedCat = this.$route.params.name;
                } else {
                    this.selectedCat = null;
                }

                // this.sfw = !Store.page.channel.temp.nsfw;
            },

            /**
             * Sets the default value for suggestCats (uses user's already subscriber channels)
             *
             * @return void
             */
            setDefaultChannels() {
                let array = [];
                Store.state.subscribedChannels.forEach((element) => {
                    array.push(element.name + ' (' + element.location.name + ')')
                });

                this.suggestedCats = array;
            },

            /**
             * Submits the form.
             *
             * @return void
             */
            submit() {
                if (!!this.slug) {
                    if (!this.isHumtogAdministrator && this.submission.user_id != this.auth.id) {
                        return;
                    }
                }
                if (!this.title) {
                    this.getTitle()
                    return
                }

                this.loading = true;
                let formData = this.prepareFormData();
                axios.post('/submissions', formData)
                    .then(response => {
                        this.loading = false;

                 //       if (!this.slug) {
                   //         Store.state.submissions.likes.push(response.data.id);
                     //   }

                        this.$router.push('/p/' + response.data.slug);

                        // this.close();
                        // this.reset();
                    })
                    .catch(error => {
                        console.log(error)

                        this.loading = false;
                        this.errors = error.response.data.errors;
                    });
            },

            prepareFormData() {
                let formData = new FormData();

                if (this.slug) {
                    formData.append('slug', this.slug);
                }

                this.selectedCat = this.selectedCat.split(' ')[0];
                formData.append('title', this.title);
                formData.append('channel_name', this.selectedCat);
                formData.append('nsfw', this.sfw);
                formData.append('type', this.submissionType);
                formData.append('submissionType', this.typeOfSubmission);
                formData.append('location', this.location);
                formData.append('original', !!this.original);
                formData.append('timeRelevance', this.timeRelevance);
                formData.append('newsworthy', !!this.newsworthy);

                switch (this.submissionType) {
                    case 'Question':
                        formData.append('description', this.text);
                        break;

                    case 'News':
                        formData.append('url', this.submitURL);
                        formData.append('description', this.text);
                        break;
                    case 'link':
                        formData.append('url', this.submitURL);
                        formData.append('description', this.text);
                        break;
                    case 'gif':
                        formData.append('gif_id', this.gif_id);
                        break;
                    case 'text':
                        formData.append('description', this.text);
                        break;
                    case 'article':
                        formData.append('description', this.text);
                        break;
                    case 'img':
                        let arr = _.map(this.photos, 'id');
                        for (let i = 0; i < arr.length; i++) {
                            formData.append('photos_id[]', arr[i]);
                        }
                        formData.append('description', this.text);
                        break;

                }

                return formData;
            },

            getTitle() {
                if (!this.submitURL.trim()) return;

                this.loading = true;

                axios
                    .get('/links/title', {
                        params: {
                            url: this.submitURL
                        }
                    })
                    .then(response => {
                        this.title = response.data.data.title;
                        if (!!response.data.data.content) {
                            this.text = response.data.data.content
                        }

                        this.errors.url = [];

                        this.loading = false;
                        this.submit();
                    })
                    .catch(error => {
                        this.errors = error.response.data.errors;
                        this.loading = false;
                    });
            },

            /**
             * Searches through channels.
             *
             * @param string typed
             * @return void
             */
            getSuggestedChannels: _.debounce(function (typed) {
                if (!typed) return;

                this.loadingChannels = true;

                axios
                    .get('/search', {
                        params: {
                            type: 'Channels',
                            keyword: typed
                        }
                    })
                    .then(response => {
                        let array = [];
                        response.data.data.forEach((element) => {
                            array.push(element.name + ' (' + element.location.name + ')')
                        });

                        this.suggestedCats = array;
                        this.loadingChannels = false;
                    })
                    .catch(error => {
                        console.log(error)
                        this.loadingChannels = false;
                    });
            }, 600),

            changeSubmissionType(newType) {
                this.submissionType = newType;
            },

            reset() {
                this.errors = [];

                this.loading = false;
                this.loadingChannels = false;
                this.selectedCat = null;
                this.suggestedCats = [];
                this.title = '';
                this.sfw = true;

                // Link
                this.submitURL = '';
                this.loadingTitle = false;

                // Text
                this.preview = false;
                this.text = '';

                // Photo
                this.photos = [];
                this.previewPhotoImage = '';
                this.previewPhotoFileName = '';
                this.previewPhotoModal = false;

                // GIF
                // this.gifTempArray = [];
                // this.gif_id = null;
                // this.previewGifImage = '';
                // this.previewGifFileName = '';
                // this.previewGifModal = fals;
            }
        }
    };
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/submission/HumTogSubmission.vue